module.exports = __webpack_public_path__ + "img/2.6f4d67a7.png";